var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 149,
    height: 161,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5.24 5.66"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".logoIcon_svg__fil1{fill:#fff;fill-rule:nonzero}"))), /*#__PURE__*/React.createElement("g", {
    id: "logoIcon_svg__Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logoIcon_svg___2975512983568"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.27.29a2.62 2.62 0 0 1 1.97 2.54c0 1.22-.84 2.25-1.97 2.54v-.34a2.3 2.3 0 0 0 1.65-2.2c0-1.05-.7-1.93-1.65-2.21V.29zm-1.3 5.08A2.628 2.628 0 0 1 0 2.83C0 1.6.84.58 1.97.29v.33C1.02.9.32 1.78.32 2.83c0 1.04.7 1.92 1.65 2.2v.34z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logoIcon_svg__fil1",
    transform: "rotate(-23 7.054 -1.266) scale(1.77154)",
    d: "M0 0h1.6v.13H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logoIcon_svg__fil1",
    transform: "rotate(48 .97 3.065) scale(1.77154)",
    d: "M0 0h1.01v.13H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "logoIcon_svg__fil1",
    transform: "rotate(56 -1.993 2.434) scale(1.77154)",
    d: "M0 0h1.6v.13H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "logoIcon_svg__fil1",
    transform: "rotate(-51 6.65 -.2) scale(1.77153)",
    d: "M0 0h.86v.13H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "logoIcon_svg__fil1",
    cx: 3.67,
    cy: 1.65,
    r: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "logoIcon_svg__fil1",
    cx: 3.67,
    cy: 3.93,
    r: 0.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "logoIcon_svg__fil1",
    cx: 1.07,
    cy: 2.78,
    r: 0.45
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "logoIcon_svg__fil1",
    cx: 2.62,
    cy: 5.21,
    r: 0.45
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "logoIcon_svg__fil1",
    cx: 2.62,
    cy: 0.45,
    r: 0.45
  })))));
};

export { SvgLogoIcon as ReactComponent };
export default __webpack_public_path__ + "logoIcon.svg";